import { proxy } from "valtio";

export type LeadRowActiveState =
  | "client"
  | "assignment"
  | "member"
  | "qr"
  | "events"
  | false;

type SelectedLead = {
  leadId: string | null;
  state: LeadRowActiveState;
};

export const homeState = proxy<{
  selectedLead: SelectedLead | null;
  linkCreatorLeadId: string | null;
  linkCreatorIsDefaultLead: boolean | null;
  contractCreatorLeadId: string | null;
  contractCreatorProfileId: string | null;
  contractCreatorInitialStartDate: string | null;
  contractCreatorInitialCompanyName: string | null;
  contractCreatorEditContractId: string | null;
  contractCreatorEditOrgCompanyId: string | null;
  contractCreatorEditEndDate: string | null;
  contractCreatorEditHourlyRate: number | null;
  contractCreatorEditServiceLevel: number | null;
  skillStackSkillName: string | null;
  organizationIconName: string | null;
  assignmentDrawerLeadId: string | null;
  matrixDrawerLeadId: string | null;
}>({
  selectedLead: null,
  linkCreatorLeadId: null,
  linkCreatorIsDefaultLead: null,
  contractCreatorLeadId: null,
  contractCreatorProfileId: null,
  contractCreatorInitialStartDate: null,
  contractCreatorInitialCompanyName: null,
  contractCreatorEditContractId: null,
  contractCreatorEditOrgCompanyId: null,
  contractCreatorEditEndDate: null,
  contractCreatorEditHourlyRate: null,
  contractCreatorEditServiceLevel: null,
  skillStackSkillName: null,
  organizationIconName: null,
  assignmentDrawerLeadId: null,
  matrixDrawerLeadId: null,
});

export const getNextLeadRowActiveState = (
  prev: LeadRowActiveState,
  state: LeadRowActiveState,
) => (prev === state ? false : state);
